"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreInitiativesIdMapSlice = void 0;
const xuder_1 = require("@sonar-software/xuder");
const state_1 = require("./state.js");
const _lib_1 = require("../../../lib/index.js");
const empty = {
    ownerIds: [],
    scopeCounts: {},
    stakeholders: [],
    tagIds: [],
    tasks: []
};
const taskArrayUpdateOptions = {
    afterReorder: (task, index) => (Object.assign(Object.assign({}, task), { orderIndex: index })),
    idSelector: (task) => task.initiativeTaskId
};
function rebuildReferenceEntry(entry, existingEntry) {
    return Object.assign(Object.assign({}, existingEntry), { ownerIds: (0, _lib_1.rebuildArray)(existingEntry.ownerIds, entry.ownerIds), scopeCounts: entry.scopeCounts ? Object.assign({}, entry.scopeCounts) : Object.assign({}, existingEntry.scopeCounts), stakeholders: (0, _lib_1.rebuildArray)(existingEntry.stakeholders, entry.stakeholders), tagIds: (0, _lib_1.rebuildArray)(existingEntry.tagIds, entry.tagIds), tasks: (0, _lib_1.rebuildArray)(existingEntry.tasks, entry.tasks, taskArrayUpdateOptions) });
}
exports.coreInitiativesIdMapSlice = (0, xuder_1.createUpdateSyncSlice)({
    name: 'CoreInitiativesIdMap',
    state: state_1.defaultInitiativesIdMapState,
    transform: (action, state = {}) => {
        var _a;
        if (!action.length) {
            return state;
        }
        const updatedState = Object.assign({}, state);
        for (const entry of action) {
            const key = entry.initiativeId;
            updatedState[key] = rebuildReferenceEntry(entry, (_a = state[key]) !== null && _a !== void 0 ? _a : Object.assign({}, empty));
        }
        return updatedState;
    }
});
//# sourceMappingURL=update.js.map